// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"89ca91e1","389":"018d75ac","453":"8c92125d","732":"1880163b","857":"50c06bf9","977":"5f12f417"}[chunkId] + ".chunk.js";
};